import { getTheme } from "@ane/ui-components/lib/Styling";
const ENTITY_NAME = "Data source";
const PAGE_TITLES = {
  create: `Create a data source`,
  view: `View data source`,
  list: `Manage data sources`
};
var validateStatus = /* @__PURE__ */ ((validateStatus2) => {
  validateStatus2["ValidateSuccess"] = "ValidateSuccess";
  validateStatus2["ValidateFailed"] = "ValidateFailed";
  validateStatus2["Unknown"] = "Unknown";
  return validateStatus2;
})(validateStatus || {});
var validateStatusFriendly = /* @__PURE__ */ ((validateStatusFriendly2) => {
  validateStatusFriendly2["ValidateSuccess"] = "Validation succeeded";
  validateStatusFriendly2["ValidateFailed"] = "Validation failed";
  validateStatusFriendly2["Unknown"] = "Validation in progress";
  return validateStatusFriendly2;
})(validateStatusFriendly || {});
var DataSourceTypes = /* @__PURE__ */ ((DataSourceTypes2) => {
  DataSourceTypes2["Main"] = "Main";
  DataSourceTypes2["Sample"] = "Sample";
  return DataSourceTypes2;
})(DataSourceTypes || {});
const ValidationIcons = {
  [
    "ValidateSuccess"
    /* ValidateSuccess */
  ]: {
    iconName: "CompletedSolid",
    color: getTheme().palette.green
  },
  [
    "ValidateFailed"
    /* ValidateFailed */
  ]: {
    iconName: "Blocked2Solid",
    color: getTheme().palette.redDark
  },
  [
    "Unknown"
    /* Unknown */
  ]: {
    iconName: "SyncStatusSolid",
    color: getTheme().palette.yellow
  }
};
const DataLocationComponentConstants = {
  SPDoubleConfirmDialog: {
    confirmBtn: {
      label: "Confirm",
      ariaLabel: "Confirm"
    },
    cancelBtn: {
      label: "Cancel",
      ariaLabel: "Cancel"
    },
    title: "Confirm change",
    subText: `Do you want to change the service principal name?`,
    getInfo: (spName) => `(You will not be able to revert back to ${spName}. Hit cancel if you are not the owner of the service principal)`
  },
  AAStreamExpirationDateField: {
    name: "AAStreamExpirationDate",
    label: "AAStream Expiration Date",
    description: "Please enter AAStream Expiration Date"
  },
  AAStreamLocationPrefixField: {
    name: "AAStreamLocationPrefix",
    label: "AAStream Storage Prefix",
    description: "e.g., /shares/<VC name>/local/projects/FlashResultAAStream/",
    errorMsg: "Please provide a relative path"
  }
};
const SpecialColumnsComponentConstants = {
  FlightDoubleConfirmDialog: {
    confirmBtn: {
      label: "Confirm",
      ariaLabel: "Confirm"
    },
    cancelBtn: {
      label: "Cancel",
      ariaLabel: "Cancel"
    },
    title: "Confirm change",
    subText: `Do you want to change the flight format?`
  }
};
const DataSourceTypeOptions = [
  {
    key: "Main",
    text: "Main"
    /* Main */
  },
  {
    key: "Sample",
    text: "Sample"
    /* Sample */
  }
];
export {
  DataLocationComponentConstants,
  DataSourceTypeOptions,
  DataSourceTypes,
  ENTITY_NAME,
  PAGE_TITLES,
  SpecialColumnsComponentConstants,
  ValidationIcons,
  validateStatus,
  validateStatusFriendly
};
//# sourceMappingURL=DataSource.constants.js.map
